var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgInfoIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM13.35 7.95C13.35 8.69558 12.7456 9.3 12 9.3C11.2544 9.3 10.65 8.69558 10.65 7.95C10.65 7.20442 11.2544 6.6 12 6.6C12.7456 6.6 13.35 7.20442 13.35 7.95ZM12.9 11.1V16.5H13.35C13.5985 16.5 13.8 16.7015 13.8 16.95C13.8 17.1985 13.5985 17.4 13.35 17.4H12.9H11.1H10.65C10.4015 17.4 10.2 17.1985 10.2 16.95C10.2 16.7015 10.4015 16.5 10.65 16.5H11.1V11.1H12.9Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfoIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/infoIcon.878423a1.svg";
export { ForwardRef as ReactComponent };